"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.publishCountForMethod = exports.publishAtmsUserMetrics = exports.publishBrowserMetrics = void 0;
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const js_cookie_1 = __importDefault(require("js-cookie"));
exports.publishBrowserMetrics = (initialMetricsPublisher) => {
    const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('BrowserInfo');
    actionMetricsPublisher.publishStringTruncate('UserAgent', navigator.userAgent);
    const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    actionMetricsPublisher.publishCounter('ViewportWidth', viewportWidth);
    actionMetricsPublisher.publishCounter('ViewportHeight', viewportHeight);
};
exports.publishAtmsUserMetrics = (initialMetricsPublisher, sessionCookieName) => {
    const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('AtmsUserInfo');
    const sessionJwt = js_cookie_1.default.get(sessionCookieName);
    if (sessionJwt == null) {
        actionMetricsPublisher.publishCounter('MissingSession', 1);
    }
    else {
        try {
            const session = jsonwebtoken_1.default.decode(sessionJwt);
            const impersonatingUserId = session['sysAdminAccess'] ? session['userId'] : null;
            actionMetricsPublisher.publishCounter('UserId', impersonatingUserId ? session['sysAdmin.userId'] : session['userId']);
            if (impersonatingUserId) {
                actionMetricsPublisher.publishCounter('ImpersonatingUserId', impersonatingUserId);
            }
            actionMetricsPublisher.publishString('Role', session['role']);
            actionMetricsPublisher.publishCounter('OrganizationId', session['organizationId']);
            actionMetricsPublisher.publishCounter('Success', 1);
        }
        catch (err) {
            actionMetricsPublisher.publishCounter('ErrorReadingSession', 1);
            console.error('Problem reading session information to report with metrics', err);
        }
    }
};
exports.publishCountForMethod = (initialMetricsPublisher, methodName) => {
    const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod(methodName);
    actionMetricsPublisher.publishCounter('Count', 1);
    return actionMetricsPublisher;
};
//# sourceMappingURL=metrics.js.map